import '../Sass/App.scss';
import React, { useState, useEffect } from 'react';
import { Deck } from './Deck';

let CARD_WIDTH = 150;

export function MLDeck(props) {

    const [discard, setDiscard] = useState([])
    const [deck, setDeck] = useState([props.deck])
    
    function getName() {
        if (props.type=='ml') {
            return "x = " + (props.index+1)
        } else {
            return deck[0][0].card_type == 'viral_function' ? 'Viral Functions' : 'Viral Listeners'
        }
    }

    return (
        <div style={ props.type == 'viral' ? {display: 'block', height: CARD_WIDTH + 20, float: 'left'} : {display: 'block', width: CARD_WIDTH + 20, float: 'left'}}>
            <Deck currentHome={props.type + '_' + props.index} name={getName()} cards={deck[0]} decks={deck} cardWidth={CARD_WIDTH} setCards={setDeck} cardStyle='deck' deckIndex={0} key={props.index} />
            <Deck currentHome={props.type + '_discard_' + props.index} name='Discard Pile' cards={discard} cardWidth={CARD_WIDTH} clickHandler={props.clickHandler} setCards={setDiscard} cardStyle='discard' type={props.type} />
        </div>
    ) 
}
